import React from 'react';
import { motion } from 'framer-motion';

const About = () => {
    return (
        <section id="about" className="section about-section">
            <div className="container">
                <motion.div
                    className="about-content"
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6 }}
                >
                    <h2 className="section-title">הגישה שלנו</h2>
                    <p className="about-text">
                        בסטודיו של בר בן אבו, אנו מאמינים שעיצוב הוא הרבה מעבר לאסתטיקה.
                        הוא השילוב המדויק בין מינימליזם, פרקטיקה ואלגנטיות.
                        כל פרויקט מתחיל בהקשבה עמוקה לצרכי הלקוח ומסתיים בחלל שמרגיש נכון,
                        נושם ומותאם אישית. הקווים הנקיים והחומרים הטבעיים הם השפה שלנו ליצירת יוקרה שקטה.
                    </p>
                </motion.div>
            </div>
        </section>
    );
};

export default About;
